import PensionKlatpensionGraph from './PensionKlatpensionGraph';

export default PensionKlatpensionGraph;
